import React, {useEffect, useState} from 'react';
import {ResponsiveBar} from '@nivo/bar'

const Report3OnlineInfo = props => {
    const {responseData} = props;
    const [legend,setLegend] = useState(Object.values(responseData.onlineInfo.legend))
    const windowWith = window.innerWidth;

    useEffect(() => {
        for(let i = 0; i < responseData.onlineInfo.data.length; i++){
            let obj = responseData.onlineInfo.data[i];
            for(let prop in obj){
                if(obj.hasOwnProperty(prop) && obj[prop] !== null && !isNaN(obj[prop])){
                    obj[prop] = +obj[prop];
                }
            }
        }
    },[])

    return (
        <div className="row  mt-3">
            <div className="col-xl-12">
                <div className="card">
                    <div className="card-body">
                        <h3 className="wl-title wl-title-color">{responseData.onlineInfo.reportName}</h3>
                        <div>
                            {responseData.onlineInfo.usedFilter.replace(/(?:\r\n|\r|\n)/g, '<br />').split('<br />').map((e,i) => (
                                <div key={i}>
                                    {e}
                                </div>
                            ))}
                        </div>
                        <div style={{minHeight: '300px', height: `${responseData.onlineInfo.data.length * 50}px`, width: '100%', position: 'relative'}}>
                            <ResponsiveBar
                                data={responseData.onlineInfo.data}
                                keys={legend}
                                layout={'horizontal'}
                                indexBy="title"
                                enableLabel={false}
                                margin={{ top: 50, right: 190, bottom: 50, left: windowWith/3 }}
                                padding={0.3}
                                colors={({ id, data }) => '#'+responseData.onlineInfo.color[id]}
                                borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
                                axisTop={null}
                                axisRight={null}
                                labelSkipWidth={12}
                                labelSkipHeight={12}
                                labelTextColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
                                legends={[
                                    {
                                        dataFrom: 'keys',
                                        anchor: 'bottom-right',
                                        direction: 'column',
                                        justify: false,
                                        translateX: 130,
                                        translateY: 0,
                                        itemsSpacing: 2,
                                        itemWidth: 100,
                                        itemHeight: 20,
                                        itemDirection: 'left-to-right',
                                        itemOpacity: 0.85,
                                        symbolSize: 20,
                                        effects: [
                                            {
                                                on: 'hover',
                                                style: {
                                                    itemOpacity: 1
                                                }
                                            }
                                        ]
                                    }
                                ]}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Report3OnlineInfo;
